import { busyIntegrationActionTypes } from '../../actions/integrations/busyIntegrationAction';

const BusyIntegrationReducers = (state = {}, action) => {
  switch (action.type) {
  case busyIntegrationActionTypes.GET_BUSY_CONNECTIONS.LOADING: {
    const { getBusyConnectionsLoading } = action;
    return {
      ...state,
      getBusyConnectionsLoading,
    };
  }

  case busyIntegrationActionTypes.GET_BUSY_CONNECTIONS.SUCCESS: {
    const { busyConnections } = action;
    return {
      ...state,
      busyConnections,
    };
  }

  case busyIntegrationActionTypes.DELETE_BUSY_CONNECTION.LOADING: {
    const { deleteBusyConnectionLoading } = action;
    return {
      ...state,
      deleteBusyConnectionLoading,
    };
  }

  case busyIntegrationActionTypes.CONNECT_TO_BUSY.LOADING: {
    const { connectToBusyLoading } = action;
    return {
      ...state,
      connectToBusyLoading,
    };
  }

  case busyIntegrationActionTypes.SYNC_BUSY_PRODUCT.LOADING: {
    const { syncProductLoading } = action;
    return {
      ...state,
      syncProductLoading,
    };
  }

  case busyIntegrationActionTypes.SYNC_BUSY_CUSTOMER.LOADING: {
    const { syncVendorLoading } = action;
    return {
      ...state,
      syncVendorLoading,
    };
  }

  case busyIntegrationActionTypes.REFRESH_BUSY_CONNECTIONS.LOADING: {
    const { refreshBusyConnectionsLoading } = action;
    return {
      ...state,
      refreshBusyConnectionsLoading,
    };
  }

  case busyIntegrationActionTypes.CONNECT_TO_BUSY_LOCATION.LOADING: {
    const { connectToBusyLocationLoading } = action;
    return {
      ...state,
      connectToBusyLocationLoading,
    };
  }

  // push grn to busy

  case busyIntegrationActionTypes.PUSH_GRN_TO_BUSY.LOADING: {
    const { pushGrnToBusyLoading } = action;
    return {
      ...state,
      pushGrnToBusyLoading,
    };
  }

  // push invoice to busy

  case busyIntegrationActionTypes.PUSH_INVOICE_TO_BUSY.LOADING: {
    const { pushInvoiceToBusyLoading } = action;
    return {
      ...state,
      pushInvoiceToBusyLoading,
    };
  }

  // push expense to busy

  case busyIntegrationActionTypes.PUSH_EXPENSE_TO_BUSY.LOADING: {
    const { pushExpenseToBusyLoading } = action;
    return {
      ...state,
      pushExpenseToBusyLoading,
    };
  }

  // push Credit note to busy

  case busyIntegrationActionTypes.PUSH_CREDIT_NOTE_TO_BUSY.LOADING: {
    const { pushCreditNoteToBusyLoading } = action;
    return {
      ...state,
      pushCreditNoteToBusyLoading,
    };
  }

  // push Debit note to busy

  case busyIntegrationActionTypes.PUSH_DEBIT_NOTE_TO_BUSY.LOADING: {
    const { pushDebitNoteToBusyLoading } = action;
    return {
      ...state,
      pushDebitNoteToBusyLoading,
    };
  }

  default:
    return state;
  }
};

export default BusyIntegrationReducers;
